import { useLanguage } from '../utils/LanguageContext';
import { FormButton, FormChoice, ValidatedForm } from './common/ValidatedForm';
import { useAuth } from '../utils/AuthContext.js';
import translations from './ComponentsTranslations.lang.json';
import { useEffect, useState } from 'react';
import EmployerForm from './EmployerForm.js';
import { Card, Col, Row, Space } from 'antd';
import EmployeesManager from './EmployeesManager.js';
import EmployerView from './EmployerView.js';
import { EditableValues } from './common/CommonComponents.js';
import { useBooleanState } from './common/commonHooks.js';

const EmployerSelect = ({ selectedEmployerId, handleSelectEmployer, handleAddEmployerAction }) => {
  const { lang } = useLanguage(translations);
  const { administratedEmployers } = useAuth();

  const employerOptions = administratedEmployers
    ? administratedEmployers.map((e) => ({ value: e.employerId, label: e.employerName }))
    : [];

  return (
    <Card title={lang('manageEmployers')}>
      <Row>
        {employerOptions.length > 0 && (
          <Col sm={24} md={18}>
            <ValidatedForm>
              <FormChoice
                name="employerId"
                type="select"
                label={lang('selectEmployer')}
                options={employerOptions}
                value={selectedEmployerId}
                onChange={handleSelectEmployer}
              />
            </ValidatedForm>
          </Col>
        )}
        <Col sm={24} md={6}>
          <ValidatedForm>
            <FormButton label={lang('addEmployerButtonLabel')} onClick={handleAddEmployerAction}>
              {lang('addEmployer')}
            </FormButton>
          </ValidatedForm>
        </Col>
      </Row>
    </Card>
  );
};

const EmployersManager = () => {
  const { lang } = useLanguage(translations);
  const { user, administratedEmployers } = useAuth();

  const addingEmployer = useBooleanState(false);
  const addingEmployee = useBooleanState(false);

  const [selectedEmployerId, setSelectedEmployerId] = useState(null);

  useEffect(() => {
    if (administratedEmployers?.length > 0 && !selectedEmployerId) {
      setSelectedEmployerId(administratedEmployers[0].employerId);
    }
  }, [administratedEmployers, selectedEmployerId]);

  const selectedEmployer =
    administratedEmployers && administratedEmployers.find((e) => e.employerId === selectedEmployerId);

  const handleAddEmployer = async ({ employerId }) => {
    addingEmployer.setFalse();
    setSelectedEmployerId(employerId);
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      {user.isThirdPartyPayrollAdmin && !addingEmployer.value && !addingEmployee.value && (
        <EmployerSelect
          selectedEmployerId={selectedEmployerId}
          handleSelectEmployer={setSelectedEmployerId}
          handleAddEmployerAction={addingEmployer.setTrue}
        />
      )}
      {selectedEmployer && !addingEmployer.value && !addingEmployee.value && (
        <Card
          title={
            <>
              {selectedEmployer.employerName}: {lang('employerDetailsSuffix')}
            </>
          }
        >
          <EditableValues
            componentData={{ employer: selectedEmployer }}
            editButtonLabel={lang('editEmployer')}
            viewComponent={EmployerView}
            editComponent={EmployerForm}
          />
        </Card>
      )}
      {selectedEmployer && !addingEmployer.value && (
        <EmployeesManager employerId={selectedEmployerId} addingEmployee={addingEmployee} />
      )}
      {addingEmployer.value && (
        <Card title={lang('newEmployer')}>
          <EmployerForm submitLabel={lang('addEmployer')} onFinish={handleAddEmployer} />
          <FormButton onClick={addingEmployer.setFalse}>{lang('cancel')}</FormButton>
        </Card>
      )}
    </Space>
  );
};

export default EmployersManager;
